import _regenerator from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/regenerator.js";
import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.iterator.js";
import axios from "axios";
import fun from "../fun";
import base64_encode from "utils/base64_encode";
import Fun from "../fun";

// 创建axios实例
var service = axios.create({
  // baseURL: "https://gateway.test.zgxiyinli.com/api/portal", // 使用完整域名
  //   baseURL:process.env.VUE_APP_BASE_API,
  // +"/api/portal"
  // baseURL:process.env.VUE_APP_BASE_API+"/api/portal", // 使用完整域名
  timeout: 15000,
  // 请求超时时间
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});

// 创建取消令牌存储
var pendingRequests = new Map();

/**
 * 生成请求的唯一键
 * @param {Object} config 请求配置
 * @returns {string} 请求的唯一键
 */
var generateRequestKey = function generateRequestKey(config) {
  var url = config.url,
    method = config.method,
    params = config.params,
    data = config.data;
  return [url, method, JSON.stringify(params), JSON.stringify(data)].join("&");
};

/**
 * 添加请求到待处理Map
 * @param {Object} config 请求配置
 */
var addPendingRequest = function addPendingRequest(config) {
  var requestKey = generateRequestKey(config);
  config.cancelToken = config.cancelToken || new axios.CancelToken(function (cancel) {
    if (!pendingRequests.has(requestKey)) {
      pendingRequests.set(requestKey, cancel);
    }
  });
};

/**
 * 移除待处理请求
 * @param {Object} config 请求配置
 */
var removePendingRequest = function removePendingRequest(config) {
  var requestKey = generateRequestKey(config);
  if (pendingRequests.has(requestKey)) {
    var cancel = pendingRequests.get(requestKey);
    cancel(requestKey);
    pendingRequests.delete(requestKey);
  }
};
// PHPSESSID由服务器端管理生命周期，不需要客户端刷新逻辑

// 请求拦截器
service.interceptors.request.use(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(config) {
    var baseURL, tid, requestPath, access_token;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (config.url.startsWith("/xyl-open")) {
            baseURL = process.env.VUE_APP_SASS_API;
          } else if (config.url.startsWith("/member") || config.url.startsWith("/settlement") || config.url.startsWith("/rae") || config.url.startsWith("/points")) {
            baseURL = process.env.VUE_APP_BASE_API;
          } else {
            baseURL = process.env.VUE_APP_BASE_API;
          }
          config.baseURL = baseURL;
          // 检查是否存在相同的待处理请求，如果有则取消之前的请求
          removePendingRequest(config);
          addPendingRequest(config);
          // 每次请求都获取最新的PHPSESSID
          // let PHPSESSID = fun.getCookie("PHPSESSID");
          // let Tid = localStorage.getItem("TID");
          tid = fun.getKey('tid');
          requestPath = config.url; // 处理URL路径，避免重复的/lifec路径
          // 如果请求路径已包含/lifec前缀，则移除它
          if (requestPath.startsWith("/lifec")) {
            requestPath = requestPath.substring("/lifec".length);
          }

          // 确保路径以/开头
          if (!requestPath.startsWith("/")) {
            requestPath = "/" + requestPath;
          }

          // 更新config中的url
          config.url = requestPath;
          access_token = fun.getKey("access_token") || localStorage.getItem("access_token"); // 添加PHPSESSID到Authorization头，使用Bearer格式
          if (access_token) {
            config.headers["Authorization"] = "Bearer ".concat(access_token);
          }
          // else if (PHPSESSID) {
          //   config.headers["Authorization"] = `Bearer ${PHPSESSID}`;
          // }
          if (tid) {
            config.headers["Tid"] = "".concat(tid);
          }
          // 添加时间戳防止缓存
          if (config.method === "get") {
            config.params = _objectSpread(_objectSpread({}, config.params), {}, {
              _t: Date.now()
            });
          }
          // 添加loading控制
          if (config.loading) {
            _Toast.loading({
              message: config.loadingText || "加载中...",
              forbidClick: true,
              duration: 0
            });
            config._loadingInstance = _Toast; // 保存实例
          }
          return _context.a(2, config);
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}(), function (error) {
  return Promise.reject(error);
});

// 响应拦截器
service.interceptors.response.use(function (response) {
  // 请求完成后移除待处理请求
  removePendingRequest(response.config);
  var res = response.data;
  // 清除loading
  if (response.config._loadingInstance) {
    _Toast.clear();
  }
  // 处理业务响应
  if (res.code === 0) {
    return res.data;
  } else if (res.code === 4) {
    return res;
  } else if (res.code === 401 || res.msg && res.msg.includes("权限")) {
    // 权限问题，直接提示用户重新登录
    var errorMsg = "登录已过期，请前往个人中心登录";
    _Toast(errorMsg);
    // 可以在这里添加跳转到登录页的逻辑
    // window.location.href = Fun.getSiteRoot() + "/addons/yun_shop/#/AuthorizedLogin?i=1&yz_redirect=" + base64_encode(document.location.href) + "&type=5&mid=" + Fun.getKeyByMid();
    return Promise.reject(res);
  } else {
    // 处理其他业务错误
    var _errorMsg = res.msg || "请求失败";
    _Toast(_errorMsg);
    return Promise.reject(new Error(_errorMsg));
  }
}, function (error) {
  var _error$response$data;
  // 请求失败后移除待处理请求
  if (error.config) {
    removePendingRequest(error.config);
  }
  if (axios.isCancel(error)) {
    var _error$config;
    // 请求被取消时清除loading
    if ((_error$config = error.config) !== null && _error$config !== void 0 && _error$config._loadingInstance) {
      _Toast.clear();
    }
    return Promise.reject(error);
  }
  // 处理HTTP错误
  var errorMsg = "网络错误";
  if (error.response) {
    var _error$config2;
    // 清除loading
    if ((_error$config2 = error.config) !== null && _error$config2 !== void 0 && _error$config2._loadingInstance) {
      _Toast.clear();
    }
    switch (error.response.status) {
      case 401:
        errorMsg = "登录已过期，请重新登录";
        _Toast(errorMsg);
        // 可以在这里添加跳转到登录页的逻辑
        return Promise.reject(error.response);
      // 可以添加其他状态码处理
      default:
        errorMsg = ((_error$response$data = error.response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.msg) || "HTTP\u9519\u8BEF: ".concat(error.response.status);
        _Toast(errorMsg);
        return Promise.reject(new Error(errorMsg));
    }
  }
  _Toast(errorMsg);
  return Promise.reject(new Error(errorMsg));
});

/**
 * 封装GET请求
 * @param {string} url 请求地址
 * @param {Object} params 请求参数
 * @param {Object} config 额外配置
 * @returns {Promise}
 */
export function get(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return service.get(url, _objectSpread({
    params: params
  }, config));
}

/**
 * 封装POST请求
 * @param {string} url 请求地址
 * @param {Object} data 请求数据
 * @param {Object} config 额外配置
 * @returns {Promise}
 */
export function post(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return service.post(url, data, config);
}

/**
 * 手动取消请求
 * @param {string} url 请求地址
 * @param {string} method 请求方法
 * @param {Object} params 请求参数
 * @param {Object} data 请求数据
 */
export function cancelRequest(url) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "get";
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var requestKey = generateRequestKey({
    url: url,
    method: method,
    params: params,
    data: data
  });
  if (pendingRequests.has(requestKey)) {
    var cancel = pendingRequests.get(requestKey);
    cancel(requestKey);
    pendingRequests.delete(requestKey);
  }
}

// 创建HTTP请求工具对象
var $Http = {
  service: service,
  get: get,
  post: post,
  cancelRequest: cancelRequest
};

// 添加Vue插件安装方法
$Http.install = function (Vue) {
  // 添加到Vue原型链上，使其在组件中可以通过this.$http访问
  Vue.prototype.$Http = $Http;
};

// 导出$http对象
export default $Http;